import { enums } from 'superstruct';

export const DATA_TABLE_ITEM_TYPES = [
	'facebook-media',
	'facebook-template',
	'facebook-template-audiences',
	'facebook-template-pages',
	'facebook-template-locations',
	'facebook-template-product-catalogs',
	'facebook-template-locations-form',
	'facebook-template-locations-form-saved-audience',
	'facebook-template-budgets',
	'facebook-template-history',
	'facebook-template-history-budgets',
	'facebook-template-history-locations',
	'facebook-template-history-media-templates',
	'facebook-page',
	'role',
	'user',
	'google-ads-template',
	'google-ads-ad-accounts',
	'google-ads-template-audiences',
	'google-ads-template-merchant-centers',
	'google-ads-template-promotional-assets',
	'google-ads-template-structured-snippets',
	'google-ads-template-sitelink',
	'google-ads-template-locations',
	'google-ads-template-locations-form',
	'google-ads-template-budgets',
	'google-ads-template-goals',
	'google-ads-template-history',
	'google-ads-template-history-budgets',
	'google-ads-template-history-locations',
	'google-ads-template-history-audiences',
	'google-ads-template-history-merchant-centers',
	'google-ads-template-history-promotional-assets',
	'google-ads-template-history-group-promotional-assets',
	'google-ads-template-history-goals',
	'google-ads-media',
	'keyword',
	'promotion-asset',
	'google-my-business-media',
	'google-my-business-template',
	'google-my-business-template-history',
	'salesforce-import-preview',
	'pacing-detail',
] as const;

export const DataTableItemType = enums(DATA_TABLE_ITEM_TYPES);
/**
 * Item type is used for both changing some behaviors of data table and keying some saved data.
 */
export type DataTableItemType = (typeof DATA_TABLE_ITEM_TYPES)[number];
